var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBubble(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 123,
    viewBox: "0 0 122 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_153_3299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.972 61.0208C112.007 67.7358 110.71 74.3912 108.157 80.6018C105.603 86.8125 101.843 92.4551 97.0947 97.2033C92.3462 101.951 86.7032 105.711 80.4924 108.264C74.2815 110.817 67.6261 112.113 60.911 112.078C47.4348 112.101 34.501 106.772 24.954 97.2605C15.4069 87.7494 10.0283 74.8359 10.001 61.3598C9.91549 47.8485 15.1913 34.8547 24.6716 25.2274C34.1519 15.6001 47.063 10.1251 60.574 10.0028C88.505 9.70976 112.241 32.7508 111.972 61.0208ZM61.122 18.2428C38.26 18.5278 18.685 35.8968 18.293 60.4428C17.919 83.8358 35.748 103.443 60.605 103.768C83.662 104.068 103.305 86.4828 103.667 61.4508C103.998 38.5888 86.5 19.0168 61.122 18.2428Z",
    fill: "white",
    fillOpacity: 0.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_153_3299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.644 59.1537C25.891 43.6017 38.525 29.1257 54.344 26.2367C56.4993 25.8167 58.6954 25.6433 60.89 25.7197C63.364 25.8327 64.956 27.3417 65.042 29.6047C65.0899 30.1352 65.0279 30.6698 64.8599 31.1752C64.6919 31.6806 64.4215 32.146 64.0655 32.5422C63.7096 32.9384 63.2757 33.257 62.7911 33.478C62.3065 33.699 61.7815 33.8177 61.249 33.8267C55.289 34.2477 49.683 35.6387 44.858 39.3417C41.8547 41.5276 39.3491 44.3255 37.5065 47.5508C35.6638 50.7761 34.5259 54.3555 34.168 58.0527C34.0566 59.104 33.9313 60.1537 33.792 61.2017C33.45 63.7917 31.798 65.2667 29.422 65.1207C27.184 64.9827 25.75 63.3707 25.646 60.8607C25.622 60.2927 25.642 59.7177 25.644 59.1537Z",
    fill: "white",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_153_3299",
    x: 0,
    y: 0,
    width: 121.974,
    height: 122.079,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.909804 0 0 0 0 0.72549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_153_3299"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_153_3299",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_153_3299",
    x: 15.6343,
    y: 15.7021,
    width: 59.4233,
    height: 59.4282,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.909804 0 0 0 0 0.72549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_153_3299"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_153_3299",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubble);
export default __webpack_public_path__ + "static/media/bubble.016d3fb3bb028a438e22fdd7838a1c5d.svg";
export { ForwardRef as ReactComponent };